import { safeDefine } from "../../registration/safe-define.js";
import { MenuGroupElement } from "../../ui/menu/group.js";
//#region src/define/ui/menu-group.ts
safeDefine(MenuGroupElement);
//#endregion
